import { Typography } from '@mui/material';
import { bool, node } from 'prop-types';
import React from 'react';

const Caption = ({ right, children = null, sx }) => (
  <Typography
    variant="caption"
    sx={[
      {
        fontSize: 10,
        position: 'absolute',
        left: '45px',
        bottom: '-7px',
      },
      right && {
        left: 'auto',
        right: '45px',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Typography>
);
Caption.propTypes = {
  right: bool.isRequired,
  children: node,
};
export default Caption;
